<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="pull-left">
                            <h4 class="card-title float-left">{{name}}</h4>
                        </div>
                        <button class="all-btn add-btn pull-right" @click="addAnalog" v-if="comparison.analogs.length < 4">Аналог қўшиш</button>
                        <div class="pull-right mr-5 mt-2" v-if="comparison.exchangeRate && comparison.exchangeRate > 0">
                            1 USD = {{comparison.exchangeRate | currency('', 2, { thousandsSeparator: ' ' })}} UZS ({{comparison.exchangeRateDate}})
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 table-responsive">
                                <div class="table-wrapper">
                                  <table class="table table-striped comparison-table" :style="`min-width: ${1100 + comparison.analogs.length * 130}px`">
                                      <tr>
                                          <th rowspan="2">Таккослаш элементлари</th>
                                          <th rowspan="2" class="text-center">Таккослаш объекти</th>
                                          <th v-if="comparison.analogs.length > 0" :colspan="comparison.analogs.length" class="text-center">
                                              Таккослаш объекти (аналоги)
                                          </th>
                                      </tr>
                                      <tr>
                                          <th class="text-center" v-for="(analog, index) in comparison.analogs" :key="index" style="position: relative">
                                              аналог {{index + 1}}
                                              <i class="fa fa-remove red"
                                                 style="position: absolute;right: 3px;top: 3px;cursor: pointer"
                                                 @click="removeAnalog(index)"></i>
                                          </th>
                                      </tr>
                                      <tr>
                                          <td>Сотилиш бахоси. АКШ доллар</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index">
                                              <numeric-input v-model="analog.price.usd" :precision="2" align="center"
                                                             @input="calculateUZS(analog)"
                                                             :class="{invalid : $v.comparison.analogs.$each[index].price.usd.$error}"/>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Сотилиш бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index">
                                              <numeric-input v-model="analog.price.uzs" :precision="2" align="center"
                                                             @input="calculateUSD(analog)"
                                                             :class="{invalid : $v.comparison.analogs.$each[index].price.uzs.$error}"/>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Фойдаланилган маълумотлар манбаи</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index">
                                              <input type="text" class="form-control" v-model="analog.source" style="text-align: center"
                                                     :class="{invalid : $v.comparison.analogs.$each[index].source.$error}"/>
                                          </td>
                                      </tr>
                                     <!--  <tr>
                                          <td>Ер учатскасининг сотилиш нархи</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              таклиф нархлари
                                          </td>
                                      </tr> -->
                                      <tr>
                                          <td><i>Тузатишлар киритиш</i></td>
                                          <td :colspan="comparison.analogs.length + 1" class="text-center">
                                              Таккослаш аналоглардан баҳоланаётган объектга нисбатан
                                          </td>
                                      </tr>

                                      <!--PER AREA UNIT FIX-->
                                      <tr class="section-start">
                                          <td>Умумий майдон (кв.м.)</td>
                                          <td class="text-center">{{area | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index">
                                              <numeric-input v-model="analog.area" :precision="2" align="center"
                                                             :class="{invalid : $v.comparison.analogs.$each[index].area.$error}"/>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>1м2 бахоси</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{calculatePricePerAreaUnit(analog) | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index"
                                              class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.perAreaUnit" :precision="2"
                                                                 align="center" :allow-negative="true" readonly/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.price.perAreaUnitFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>

                                      <!--OWNERSHIP RIGHT FIX-->
                                      <tr class="section-start">
                                          <td>Берилаётган эгалик хукуки</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.ownershipRight">
                                                  <option :value="option.code"
                                                          v-for="option in ref.ownershipRights" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.ownershipRight">
                                                  <option :value="option.code"
                                                          v-for="option in ref.ownershipRights" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                             <div class="percentage">
                                                  <numeric-input v-model="analog.fix.ownershipRight" :precision="2" align="center" :allow-negative="true" readonly/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.price.ownershipRightFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>

                                      <!--FINANCIAL CONDIFIONS FIX-->
                                    <!--  <tr class="section-start">
                                          <td>Молиявий шартлари</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.financialCondition">
                                                  <option :value="option.code"
                                                          v-for="option in ref.financialConditions" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.financialCondition">
                                                  <option :value="option.code"
                                                          v-for="option in ref.financialConditions" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.financialCondition" :precision="2" align="center" :allow-negative="true"/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.price.financialConditionFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr> -->

                                      <!--TERMS OF SALE FIX-->
                                      <tr class="section-start">
                                          <td>Сотилиш шартлари</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.termsOfSale">
                                                  <option :value="option.code"
                                                          v-for="option in ref.termsOfSales" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.termsOfSale">
                                                  <option :value="option.code"
                                                          v-for="option in ref.termsOfSales" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <select class="form-control" v-model="analog.fix.termsOfSale">
                                                      <option :value="option" v-for="option in analog.termsOfSaleOptions" :key="option">{{option}}</option>
                                                  </select>
                                                  <!--<numeric-input v-model="analog.fix.termsOfSale" :precision="2" align="center" :allow-negative="true"/>-->
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.price.termsOfSaleFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>

                                      <!--AFTER SALE EXPENSES FIX-->
                                      <tr class="section-start">
                                          <td>Хариддан кейинги харажатлар</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.afterSale">
                                                  <option :value="option.code"
                                                          v-for="option in ref.afterSales" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.afterSale">
                                                  <option :value="option.code"
                                                          v-for="option in ref.afterSales" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.afterSale" :precision="2" align="center" :allow-negative="true" readonly/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.price.afterSaleFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>

                                      <!--MARKET CONDITIONS FIX-->
                                     <!-- <tr class="section-start">
                                          <td>Бозор шартлари</td>
                                          <td>
                                              Баҳолаш санаси (жорий)
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <datepicker class="form-control" format="dd/MM/yyyy" v-model="analog.marketConditionDate" :clear-button="true"></datepicker>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.marketCondition" :precision="2" align="center" :allow-negative="true"/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.price.marketConditionFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr> -->

                                      <!--NEGOTIATION PRICE CHANGE FIX-->
                                      <tr class="section-start">
                                          <td>Савдолашиш пайтидаги сотилиш бахосини пасайиши</td>
                                         <!-- <td>
                                              Сотилиш қиймати
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              Таклиф бахоси
                                          </td> -->
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <!--<numeric-input v-model="analog.fix.negotiation" :precision="2" align="center" :allow-negative="true"/>-->
                                                  <select class="form-control" align="center" :allow-negative="true" v-model="analog.fix.negotiation">
                                                      <option :value="option"
                                                              v-for="option in analog.negotiationFixOptions"
                                                              :key="option">
                                                          {{option}}
                                                      </option>
                                                  </select>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.price.negotiationFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>

                                      <!--REGIONAL FIX-->
                                    <!--  <tr class="section-start">
                                          <td>Жойлашган жойи</td>
                                          <td>
                                              <div class="text-center" v-if="region && region.parent && region.parent.label">{{region.parent.label}}</div>
                                              <div class="text-center" v-if="region && region.label">{{region.label}}</div>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <treeselect class="form-control" v-model="analog.region" :multiple="false" placeholder="Танланг..." :options="ref.provinces"></treeselect>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.region" :precision="2" align="center" :allow-negative="true"/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.price.regionFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr> -->

                                      <!--SCALABILITY FIX-->
                                      <tr class="section-start">
                                          <td>Инженерлик комуникациялар</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.engineerCommunication">
                                                  <option :value="option.code"
                                                          v-for="option in ref.engineerCommunications" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.engineerCommunication">
                                                  <option :value="option.code"
                                                          v-for="option in ref.engineerCommunications" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.engineerCommunication" :precision="2" align="center" :allow-negative="true" readonly/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.price.engineerCommunicationFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>

                                      <!--ECONOMIC CLASSIFICATION FIX-->
                                      <tr class="section-start">
                                          <td>Иктисодий таснифи (Объект инфраструктураси)</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.economicClassification">
                                                  <option :value="option.code"
                                                          v-for="option in ref.economicClassifications" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.economicClassification">
                                                  <option :value="option.code"
                                                          v-for="option in ref.economicClassifications" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.economicClassification" :precision="2" align="center" :allow-negative="true" readonly/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.price.economicClassificationFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>

                                      <!-- CHANGEABILITY TO OTHER ACTIVITY FIX-->
                                     <!-- <tr class="section-start">
                                          <td>Бошка фаолиятга узгартириш кулайлиги</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.activityChangeability">
                                                  <option :value="option.code"
                                                          v-for="option in ref.activityChangeabilityTypes" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.activityChangeability">
                                                  <option :value="option.code"
                                                          v-for="option in ref.activityChangeabilityTypes" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.activityChangeability" :precision="2" align="center" :allow-negative="true"/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.price.activityChangeabilityFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr> -->

                                      <!--ТУЗАТИШЛАР МИКДОРИ-->
                                      <tr class="section-start">
                                          <td>Тузатишлар микдори</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.fixedItemsCount}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Оралик курсаткичлари</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.middleParam | currency('', 3, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>кофф. Улушлари</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.coefficientShare | currency('', 3, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатишларни киритгандан кейинги улушларни хисобга олгандаги бахоси</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.totalFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>1 м2 бахоси сумм</td>
                                          <td class="text-right">
                                              {{comparison.calculatedPerAreaUnitPrice | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                          <td :colspan="comparison.analogs.length"></td>
                                      </tr>
                                      <tr>
                                          <td>Баҳоланаётган объект майдон м2</td>
                                          <td class="text-right">
                                              {{area | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                          <td :colspan="comparison.analogs.length"></td>
                                      </tr>
                                      <tr class="bold-row">
                                          <td>Жами йигиндиси</td>
                                          <td class="text-right">
                                              {{comparison.calculatedTotalPrice | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                          <td :colspan="comparison.analogs.length"></td>
                                      </tr>

                                  </table>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">{{$t("action.cancel")}}</button>
                                <button class="all-btn add-btn" @click="save" :disabled="processing">{{$t("action.save")}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
   //  import Datepicker from 'vuejs-datepicker';
   //  import Treeselect from '@riophae/vue-treeselect';
    import {formatDate, parseDate} from '@/shared/utils';
    import COMPARISON_REFERENCES from '@/shared/constants/realEstateComparison';
    import {required/*, requiredUnless*/, minValue, minLength, maxLength} from 'vuelidate/lib/validators';
    import {calculateAnalogFixed} from '../../shared/calcApproachesAnalogFixes'

    export default {
        name: "RealEstateLandCalculationView",
        data() {
            return {
                processing: false,
                parentName: ((this.$route.params.hasOwnProperty('parentName') && this.$route.params.parentName) ? ('/' + this.$route.params.parentName + '/') : '/'),
                realEstateId: ((this.$route.params.hasOwnProperty('realEstateId') && this.$route.params.realEstateId) ? this.$route.params.realEstateId : null),
                name: '',
                area: null,
                region: null,
                comparison: {
                    exchangeRate: null,
                    exchangeRateDate: null,
                    ownershipRight: 'permanent',
                    financialCondition: 'market',
                    termsOfSale: 'contract',
                    afterSale: 'exists',
                    engineerCommunication: 'exists',
                    economicClassification: 'high',
                    activityChangeability: 'accommodation',
                    calculatedPerAreaUnitPrice: 0,
                    calculatedTotalPrice: 0,
                    analogs: [],
                },
                ref: {
                    ...COMPARISON_REFERENCES,
                    provinces: []
                },
                ownershipRightFixData: [],
                termsOfSaleFixItem: '',
                termsOfSaleFixVisible: false
            }
        },
        validations() {
            return {
                comparison: {
                    analogs: {
                        required: required,
                        minLength: minLength(3),
                        maxLength: maxLength(5),
                        $each: {
                            source: {
                                required: required
                            },
                            area: {
                                required: required,
                                minValue: minValue(0.01)
                            },
                            price: {
                                usd: {
                                    required: required,
                                    minValue: minValue(0.01)
                                },
                                uzs: {
                                    required: required,
                                    minValue: minValue(0.01)
                                }
                            }
                        }
                    }
                }
            }
        },
        methods: {
            init() {
                const vm = this;
                this.$http.get('admin/real-estate/comparison/' + this.realEstateId)
                    .then(res => {
                        // header
                        vm.name = res.data.name;
                        vm.area = res.data.area;
                        vm.region = res.data.region;
                        vm.ref.provinces = res.data.provinces;
                        // comparisons
                        const comparison = res.data.comparison;
                        if (comparison.analogs && comparison.analogs.length > 0) {
                            comparison.analogs.forEach((analog) => {
                                analog.marketConditionDate = parseDate(analog.marketCondition);
                            });
                        }
                        vm.comparison = comparison;
                        while (vm.comparison.analogs.length < 3) {
                            this.addAnalog();
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            cancel() {
                this.$router.push(this.parentName + 'real-estate/edit/' + this.realEstateId);
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                this.comparison.analogs.forEach((analog) => {
                    analog.marketCondition = formatDate(analog.marketConditionDate);
                });
                this.$http.post('admin/real-estate/comparison/' + this.realEstateId, this.comparison)
                    .then(res => {
                        console.log(res.data);
                        this.$router.push(this.parentName + 'real-estate/edit/' + this.realEstateId);

                        this.processing = false;
                    }, err => {
                        this.processing = false;
                        console.log(err);
                    });
            },
            addAnalog() {
                if (this.comparison.analogs.length < 4) {
                    this.comparison.analogs.push({
                        source: '',
                        area: 0,
                        region: null,
                        price: {
                            usd: 0,
                            uzs: 0,
                            perAreaUnit: null,
                            perAreaUnitFixed: null,
                            ownershipRightFixed: null,
                            financialConditionFixed: null,
                            termsOfSaleFixed: null,
                            afterSaleFixed: null,
                            marketConditionFixed: null,
                            negotiationFixed: null,
                            regionFixed: null,
                            scalabilityFixed: null,
                            engineerCommunicationFixed: null,
                            economicClassificationFixed: null,
                            activityChangeabilityFixed: null
                        },
                        fix: {
                            perAreaUnit: 0,
                            ownershipRight: 0,
                            financialCondition: 0,
                            termsOfSale: 0,
                            afterSale: 0,
                            marketCondition: 0,
                            negotiation: 0,
                            region: 0,
                            engineerCommunication: 0,
                            economicClassification: 0,
                            activityChangeability: 0
                        },
                        ownershipRight: 'permanent',
                        financialCondition: 'market',
                        termsOfSale: 'contract',
                        afterSale: 'exists',
                        engineerCommunication: 'exists',
                        marketConditionDate: new Date(),
                        economicClassification: 'high',
                        activityChangeability: 'accommodation',
                        fixedItemsCount: 0,
                        middleParam: 1,
                        coefficientShare: 0,
                        totalFixed: 0
                    });
                }
            },
            removeAnalog(index) {
                this.comparison.analogs.splice(index, 1);
            },
            calculateUSD(analog) {
                if (analog.price.uzs && this.comparison && this.comparison.exchangeRate > 0) {
                    analog.price.usd = analog.price.uzs / this.comparison.exchangeRate;
                } else {
                    analog.price.usd = 0;
                }
            },
            calculateUZS(analog) {
                if (analog.price.usd && this.comparison && this.comparison.exchangeRate > 0) {
                    analog.price.uzs = analog.price.usd * this.comparison.exchangeRate;
                } else {
                    analog.price.uzs = 0;
                }
            },
            calculatePricePerAreaUnit(analog) {
                if (analog.price.uzs && analog.area && analog.area > 0) {
                    analog.price.perAreaUnit = analog.price.uzs / analog.area;
                } else {
                    analog.price.perAreaUnit = null;
                }
                this.calculate(analog);
                return analog.price.perAreaUnit;
            },
            calculateFixed(value, fixPercentage) {
                if (value && fixPercentage && fixPercentage !== 0) {
                    return value + value * (fixPercentage / 100);
                } else {
                    return value;
                }
            },
            calculate(analog) {

                if (this.comparison.termsOfSale === 'non_contract' && analog.termsOfSale === 'contract') {
                    analog.termsOfSaleOptions = [-5,-10,-15];
                    if ( analog.fix.termsOfSale >= 0) {
                        analog.fix.termsOfSale = -5;
                    }
                }else if (this.comparison.termsOfSale === 'contract' && analog.termsOfSale === 'non_contract') {
                    analog.termsOfSaleOptions = [5,10,15];
                    if (analog.fix.termsOfSale <= 0){
                        analog.fix.termsOfSale = 5;
                    }
                }else {
                        analog.termsOfSaleOptions = [0];
                        analog.fix.termsOfSale = 0;
                }

                analog.negotiationFixOptions = [0, -5, -10, -15];
                //if ()

                // fix
                analog.fix.perAreaUnit = this.calculateFixArea(this.area,analog.area);
                analog.fix.ownershipRight = calculateAnalogFixed.calculateFixOwnerShipRights(this.comparison.ownershipRight,analog.ownershipRight);
                analog.fix.afterSale = calculateAnalogFixed.calculateFixAfterSale(this.comparison.afterSale, analog.afterSale);
                analog.fix.engineerCommunication = calculateAnalogFixed.calculateFixEngineerCommunication(this.comparison.engineerCommunication,analog.engineerCommunication);
                analog.fix.economicClassification = calculateAnalogFixed.calculateFixEconomicClassifications(this.comparison.economicClassification, analog.economicClassification);

                // price
                analog.price.perAreaUnitFixed = this.calculateFixed(analog.price.perAreaUnit, analog.fix.perAreaUnit);
                analog.price.ownershipRightFixed = this.calculateFixed(analog.price.perAreaUnitFixed, analog.fix.ownershipRight);
                analog.price.financialConditionFixed = this.calculateFixed(analog.price.ownershipRightFixed, analog.fix.financialCondition);
                analog.price.termsOfSaleFixed = this.calculateFixed(analog.price.ownershipRightFixed, analog.fix.termsOfSale);
                analog.price.afterSaleFixed = this.calculateFixed(analog.price.termsOfSaleFixed, analog.fix.afterSale);
                analog.price.marketConditionFixed = this.calculateFixed(analog.price.afterSaleFixed, analog.fix.marketCondition);
                analog.price.negotiationFixed = this.calculateFixed( analog.price.afterSaleFixed, analog.fix.negotiation);
                analog.price.regionFixed = this.calculateFixed(analog.price.negotiationFixed, analog.fix.region);
                analog.price.engineerCommunicationFixed = this.calculateFixed(analog.price.regionFixed,analog.fix.engineerCommunication);
                analog.price.scalabilityFixed = this.calculateFixed(analog.price.regionFixed, analog.fix.scalability);
                analog.price.economicClassificationFixed = this.calculateFixed(analog.price.scalabilityFixed, analog.fix.economicClassification);
                analog.price.activityChangeabilityFixed = this.calculateFixed(analog.price.economicClassificationFixed, analog.fix.activityChangeability);

                let fixedItemsCount = 0;
                Object.keys(analog.fix).forEach((key) => {
                    if (analog.fix[key] && analog.fix[key] !== 0) {
                        fixedItemsCount++;
                    }
                });
                analog.fixedItemsCount = fixedItemsCount;
                analog.middleParam = analog.fixedItemsCount >= 1 ? (1 / analog.fixedItemsCount) : 1;

                let middleParamTotal = 0;
                this.comparison.analogs.forEach((function (item) {
                    if (item.middleParam) {
                        middleParamTotal += item.middleParam;
                    }
                }));
                if (middleParamTotal && middleParamTotal > 0) {
                    analog.coefficientShare = (analog.middleParam / middleParamTotal);
                } else {
                    analog.coefficientShare = 0;
                }
                analog.totalFixed = analog.price.activityChangeabilityFixed * analog.coefficientShare;

                let calculatedPerAreaUnitPrice = 0;
                this.comparison.analogs.forEach((function (item) {
                    if (item.totalFixed) {
                        calculatedPerAreaUnitPrice += item.totalFixed;
                    }
                }));
                this.comparison.calculatedPerAreaUnitPrice = calculatedPerAreaUnitPrice;
                this.comparison.calculatedTotalPrice = (this.comparison.calculatedPerAreaUnitPrice * this.area);
            },
            calculateFixArea (buildingArea, analogArea) {
                if (analogArea && analogArea > 0) {

                    if ((analogArea - buildingArea >= 100) && !(analogArea - buildingArea >= 300)) {
                        return -5;
                    } else if (buildingArea - analogArea >= 100 && !(buildingArea - analogArea >= 300)) {
                        return 5;
                    } else if (analogArea >= (buildingArea + 300)) {
                        return -10;
                    } else if ((analogArea + 300) <= buildingArea) {
                        return 10;
                    } else {
                        return 0;
                    }
                }
            }
        },
        created() {
            this.init();
        },
        computed:{

        }
    }
</script>

<style scoped>
    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #E9FAFD;
    }
    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }
    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }
    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }
    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }
    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }
</style>